// extracted by mini-css-extract-plugin
module.exports = {"selectbox":"selectBox_selectbox__1mkDq"};